import React from "react";
import { Icon, Input } from "@abb/abb-common-ux-react";

import '@abb/abb-common-ux-react/styles.css';
import "./shared.sass";
import { ISidebarDetail } from "../../models/shared/SidebarDetail";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";

interface ISidebarProperties {
  title: string;
  activeId: string;
  onSelectLink: (id: string) => any;
  listData: ISidebarDetail[];
}

class Sidebar extends React.Component<ISidebarProperties> {
  public render() {
    return (
      <Translation>
        {
          t =>
            <div className="sidenav nav-main rounded-sm rounded-lg p-2" style={{ background: 'white', height: "100vh" }}>
              <div className="row mt-2">
                <div className="col-3">
                  <Icon name="abb/caret-left" sizeClass="medium" />
                </div>
                <div className="col-6 no-padding mb-0">
                  <p className="sidebar-main-title">{t(CONSTANTS.LABEL_SELECT_FILTER)}</p>
                </div>
                <div className="col-2 mt-1">
                  <Icon name="abb/filter" sizeClass="small" />
                </div>
              </div>
              <hr className="hr-line" />
              <div className="drawer-header-bg mt-2 ">
                <div className="bg-color">
                  <span className="sidebar-title font-weight-bold">{this.props.title}</span>
                </div>
                <div className="px-2 text-center">
                  <Input
                    type="discreet"
                    dataType="text"
                    placeholder={t(CONSTANTS.LABEL_SEARCH)}
                    icon="abb/search"
                  />
                </div>
              </div>
            </div>
        }
      </Translation>
    );
  }
}

export default Sidebar;
